import { render, staticRenderFns } from "./modal-package-send-to-customer.vue?vue&type=template&id=11fbd32c"
import script from "./modal-package-send-to-customer.vue?vue&type=script&lang=js"
export * from "./modal-package-send-to-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports